var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgAudioRecording(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.117 11C.117 4.99 4.99.118 11 .118 17.01.118 21.883 4.99 21.883 11S17.01 21.883 11 21.883C4.99 21.883.117 17.011.117 11zM11 1.35c-5.33 0-9.65 4.32-9.65 9.65A9.65 9.65 0 0011 20.651a9.65 9.65 0 009.65-9.65A9.65 9.65 0 0011 1.35z",
    fill: `url(#${_id})`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.951 11a5.05 5.05 0 1110.099 0A5.05 5.05 0 015.95 11zm5.05-3.817a3.817 3.817 0 100 7.634 3.817 3.817 0 000-7.634z",
    fill: `url(#${_id2})`
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 7.381,
    y1: -3.738,
    x2: -3.624,
    y2: 13.582,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FA0000"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 9.322,
    y1: 4.162,
    x2: 4.215,
    y2: 12.198,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FA0000"
  })))));
}
export default SvgAudioRecording;